export const folderText = (foldersNumber) => {
  const isSingle = foldersNumber === 1;
  return `${ foldersNumber } folder${ isSingle ? '' : 's' }`;
};

export default folderText;
